export default {
  bucket: 'hbt-staging-ortho-raw',
};
